import React from 'react'
import { Icon } from '@mtsbank/ui-kit'
import { CountryWithIconAndTooltip } from '@entities/country'
import { ThemeType } from '@shared/types'
import { ToolTipText } from '@shared/ui/atoms'

export const getCountriesSteam = (
  isMobile: boolean,
  activeCountrySteam: string,
  theme: ThemeType,
  isActive?: boolean,
  handleOpen?: (e: any) => void
): CountryWithIconAndTooltip[] => [
  {
    country: 'Россия',
    icon: 'Russia_04032024.svg',
  },
  {
    country: 'Казахстан',
    icon: 'Kazakhstan_20082024.svg',
  },
  {
    country: 'Страны СНГ',
    icon: 'SNG_04032024.svg',
    tooltip: isMobile ? (
      <Icon
        onClick={handleOpen}
        icon="baseX24/question-circle"
        fill={activeCountrySteam === 'Страны СНГ' ? 'rgba(250, 250, 250, 0.6)' : theme.colors.icon.tertiary}
        style={{ marginLeft: '-2px', marginRight: '-4px' }}
      />
    ) : (
      <ToolTipText
        interactive
        placement="bottom"
        zIndex={999}
        onHidden={() => {}}
        onClick={(e) => {
          e.stopPropagation()
        }}
        isActive={isActive}
        hint="Азербайджан, Армения, Беларусь, Казахстан, Киргизия, Молдова, Таджикистан, Туркменистан, Узбекистан"
        activeCountrySteam={activeCountrySteam}
        style={{ marginLeft: '-2px', marginRight: '-3px' }}
      />
    ),
  },
]
